import * as React from "react"
import {
    ColumnDef,
    flexRender,
    getCoreRowModel,
    useReactTable,
} from "@tanstack/react-table";
import cn from "classnames";
import styles from "./react-table.module.scss";
import { useSharedTranslations } from "../../lib/i18n";
import { CustomLoadingOverlay } from "./loading-overlay/loading-overlay";

interface IReactTableProps<T> {
    data: T[]
    columns: ColumnDef<T, any>[];
    className?: string;
    loading?: boolean;
}

export function ReactTable<T>({
                                  data,
                                  columns,
                                  loading = false,
                                  className
                              }: IReactTableProps<T>) {
    const t = useSharedTranslations();

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className={cn(styles.container, className)}>
            <table className={styles.table} cellSpacing="0">
                <thead className={styles.head}>
                {table.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => (
                            <th key={header.id}>
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                            </th>
                        ))}
                    </tr>
                ))}
                </thead>
                <tbody>
                {table.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => (
                            <td key={cell.id} className={styles.cell}>
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
            {table.getRowModel().rows.length === 0 &&
                <div className={styles.noData}>{t("noData")}</div>
            }
            {loading && <CustomLoadingOverlay/>}
        </div>
    )
}
